import Tag from './Tag';
import React from 'react';
import { TagModel } from '../../Models/TagModel';

// @ts-ignore
import styles from './Tags.module.scss';

interface Props {
	tags: TagModel[],
	onRemove: (tag: TagModel) => void
}

const Tags: React.FC<Props> = props => {
	const {tags, onRemove} = props;

	const handleClick = (tag: TagModel) => {
		props.onRemove && props.onRemove(tag);
	};

	return (
		<div className={styles.container}>
			{props.tags.map((tag, index) => (
				<Tag label={tag.label} id={tag.id} key={index} onClick={handleClick} />
			))}
		</div>
	);
}

export default Tags;